import styled from "styled-components";

const SubHeading = styled.h3`
  margin: 0;
  padding: ${({ theme }) => theme.space[2]} 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
`;

export default SubHeading;
